import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import authReducer from "./slices/authSlice"
import modalReducer from "./slices/modalSlice"
import reservationsReducer from "./slices/reservationsSlice"
import newReservationReducer from "./slices/newReservationSlice"
import driverReducer from "./slices/driverSlice"
import alertReducer from "./slices/alertSlice"

export const store = configureStore({
  devTools: process.env.NODE_ENV === "development" ? true : false,

  reducer: {
    auth: authReducer,
    modal: modalReducer,
    reservations: reservationsReducer,
    newReservation: newReservationReducer,
    driver: driverReducer,
    alert: alertReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
